var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowBottomProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4212 0.712402H0.57883C0.0657529 0.712402 -0.195626 1.33197 0.172241 1.69983L5.59343 7.12102C5.81609 7.34368 6.18395 7.34368 6.40671 7.12102L11.8279 1.69983C12.1957 1.33197 11.9343 0.712402 11.4212 0.712402Z",
    fill: "#1062D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBottomProfile);
export default __webpack_public_path__ + "static/media/arrow-bottom-profile.0c239ed0a9005c59936319767a00c136.svg";
export { ForwardRef as ReactComponent };